var _path, _path2, _g, _ellipse, _ellipse2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisual1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
    fill: "#E3147D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.59
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.484 181.348L266.894 147.949L255.469 143.263C258.691 130.666 214.847 106.96 211.816 109.863L195.703 98.1446C180.903 90.4324 166.403 88.4558 149.977 88.4558C112.875 88.4558 73.5912 112.791 49.5116 139.453C44.5081 147.602 30.2731 150.293 33.6913 155.859C42.1904 169.701 33.135 138.875 45.703 147.949L33.6913 155.859C23.1444 155.859 30.6603 158.763 33.6913 155.859L145.814 299.942C147.197 299.978 148.584 300 149.977 300C232.699 300 288.281 234.961 296.484 181.348Z",
    fill: "url(#paint0_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4923 144.588L33.4918 144.589C31.2527 147.637 31.2527 151.774 33.4918 154.823L33.492 154.823C34.5611 156.278 47.5955 173.75 68.356 190.867C89.0992 207.97 117.687 224.828 149.845 224.828C182.002 224.828 210.59 207.97 231.332 190.867C252.093 173.75 265.127 156.279 266.197 154.826L266.197 154.826C268.439 151.777 268.44 147.637 266.197 144.591C265.127 143.136 252.093 125.665 231.332 108.547C210.59 91.4441 182.002 74.5859 149.845 74.5859C117.687 74.5859 89.0992 91.4441 68.3561 108.547C47.5954 125.664 34.5611 143.135 33.4923 144.588ZM149.845 207.493C126.715 207.493 105.057 196.554 87.6237 183.724C70.7032 171.271 57.8635 157.11 51.6597 149.701C57.8549 142.287 70.6704 128.129 87.5802 115.68C105.002 102.855 126.664 91.9213 149.845 91.9213C172.973 91.9213 194.63 102.858 212.063 115.688C228.983 128.14 241.824 142.301 248.03 149.713C241.834 157.127 229.019 171.285 212.109 183.733C194.687 196.559 173.025 207.493 149.845 207.493Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 149.5,
    rx: 36,
    ry: 35.5,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 149.5,
    rx: 19,
    ry: 18.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 103,
    width: 18,
    height: 93,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 10.8125,
    y: 59.5859,
    width: 278.066,
    height: 192.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 123.312,
    y1: 121.19,
    x2: 245.638,
    y2: 261.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisual1);
export default __webpack_public_path__ + "static/media/Visual 1.bcf777cb.svg";
export { ForwardRef as ReactComponent };